/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Questions_AsideInputs */

const en_platform_questions_aside = /** @type {(inputs: Platform_Questions_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What trainers ask before they move their week across.`)
};

const pl_platform_questions_aside = /** @type {(inputs: Platform_Questions_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O co pytają trenerzy, zanim przeniosą tu swój tydzień.`)
};

/**
* | output |
* | --- |
* | "What trainers ask before they move their week across." |
*
* @param {Platform_Questions_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_questions_aside = /** @type {((inputs?: Platform_Questions_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Questions_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_questions_aside(inputs)
	return en_platform_questions_aside(inputs)
});